<template>
  <div>
    <schoolFilter ref="schoolFilterData" @getCustomerId="checkCourseOrClass" />
    <vs-tabs class="unique_cstm_tab">
      <vs-tab v-if="is_course" @click="colorx = 'success'" label="My Calendar">
        <student-calendar-component
          :customer_id="customer_id"
          name="Courses"
        ></student-calendar-component>
      </vs-tab>

      <vs-tab v-if="is_class" @click="colorx = 'success'" label="Classes">
        <student-class-calendar-component
          :customer_id="customer_id"
          name="Classes"
        ></student-class-calendar-component>
      </vs-tab>

      <!-- <vs-tab @click="colorx = 'success'" label="Teachers">
      <teacher-calendar-component
      name="teachers"
      ></teacher-calendar-component>
    </vs-tab> -->
      <!--    <vs-tab @click="colorx = 'success'" label="Room">
        <calendar-component name="Room"></calendar-component>
      </vs-tab>  -->
      <vs-tab @click="colorx = 'success'" label="General">
        <general-calendar-component
          :customer_id="customer_id"
          name="General"
          :custom="1"
        ></general-calendar-component>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import CalendarComponent from './CalendarComponent.vue'
import TeacherCalendarComponent from './TeacherCalendarComponent.vue'
import StudentCalendarComponent from './StudentCalendarComponent.vue'
import StudentClassCalendarComponent from './StudentClassCalendarComponent.vue'
import GeneralCalendarComponent from './GeneralCalendarComponent.vue'
import { checkCourseOrClass } from '@/api/schedulerApi'
import schoolFilter from '@/components/schoolFilter/schoolFilter'

export default {
  components: {
    CalendarComponent,
    TeacherCalendarComponent,
    StudentCalendarComponent,
    StudentClassCalendarComponent,
    GeneralCalendarComponent,
    schoolFilter
  },
  data () {
    return {
      is_course: false,
      is_class: false,
      customer_id: null
    }
  },
  mounted () {
    this.checkCourseOrClass()
  },
  created () {
    if (
      Object.keys(this.$route.params).length !== 0 &&
      this.$route.params.constructor === Object
    ) {
      if (this.$route.params.from === 'Course') {
        this.is_course = true
      }
    }
    // this.checkCourseOrClass()
  },
  methods: {
    async checkCourseOrClass () {
      try {
        const payload = {
          customer_id: (this.$refs.schoolFilterData.$data.schoolId === null) ? localStorage.getItem('customer_id') : this.$refs.schoolFilterData.$data.schoolId
        }
        this.customer_id = payload.customer_id

        const response = await checkCourseOrClass(payload)

        if (response.status === 200) {
          this.is_course = response.data.data.course_exist
          this.is_class = response.data.data.class_exist
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>